module.exports = __webpack_public_path__ + "static/media/icon-refresh.5b7c381a.svg";